module.exports = __webpack_public_path__ + "img/aristocrazy-1_0.150906e2.jpg";